/*
* <license header>
*/

import React from 'react'
import { Flex, Heading, Text, View } from '@adobe/react-spectrum'
import Starburst from '@spectrum-icons/workflow/Starburst'
import Search from '@spectrum-icons/workflow/Search'
import Data from '@spectrum-icons/workflow/Data'
import ViewCard from '@spectrum-icons/workflow/ViewCard'
const FEATURES = [
  {
    icon: Starburst,
    iconColor: '#673ab7',
    title: 'Assistant with RAG',
    description: 'AI-powered assistant with Retrieval-Augmented Generation over Adobe docs. Supported LLMs: OpenAI and Anthropic. Get contextual guidance for building apps and integrating with Adobe services.'
  },
  {
    icon: Search,
    iconColor: '#2196f3',
    title: 'App Management',
    description: 'Browse, manage, and onboard Adobe App Builder applications. Track deployment status, organize your portfolio, and centralize app lifecycle across the Adobe Experience Cloud ecosystem.'
  },
  {
    icon: Data,
    iconColor: '#4caf50',
    title: 'Agentic Development & Vibe Coding',
    description: 'Dev containers with Cursor IDE, MCP Server, and Adobe I/O CLI. LLM Engine generates vibe-coding actions—from natural language to deployed code. Checkout, develop, and check-in to Customer ORG projects.'
  },
  {
    icon: ViewCard,
    iconColor: '#ff9800',
    title: 'Templates & App Types',
    description: 'Pre-built templates and support for 13+ App Builder types: Unified Shell, GenStudio, Workfront, AEM, MCP server. Bootstrap from proven structures and customize to your needs.'
  }
]

const CARD_STYLE = {
  border: '1px solid var(--card-border)',
  borderRadius: '8px',
  padding: '1.5rem',
  backgroundColor: 'var(--white)'
}

export const KeyFeaturesSection = () => (
    <View marginBottom="size-600">
      <Flex alignItems="center" gap="size-150" marginBottom="size-400">
        <View
          UNSAFE_style={{
            width: '2rem',
            height: '2rem',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #8b7cb8 0%, #673ab7 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Starburst size="S" UNSAFE_style={{ color: 'white' }} />
        </View>
        <Heading level={2} UNSAFE_style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700 }}>
          Key Features
        </Heading>
      </Flex>
      <div className="KeyFeatures-grid">
        {FEATURES.map(({ icon: Icon, iconColor, title, description }) => (
          <View key={title} UNSAFE_style={CARD_STYLE}>
            <Icon size="M" UNSAFE_style={{ color: iconColor, marginBottom: '0.75rem' }} />
            <Heading level={3} UNSAFE_style={{ margin: 0, marginBottom: '0.5rem', fontSize: '1rem', fontWeight: 600 }}>
              {title}
            </Heading>
            <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', lineHeight: 1.5 }}>
              {description}
            </Text>
          </View>
        ))}
      </div>
    </View>
)
